export const getIPAddress = async (): Promise<string | null> => {
  try {
    const ipAddressResponse = await fetch("https://api.ipify.org?format=json");
    const data = await ipAddressResponse.json();
    return data.ip || null;
  } catch {
    return null;
  }
};
